/* URL History/notes:
 * Our runtime React app talks to our backend AWS Lambda function. But you can't
 * call lambda's directly (well, not easily). To go through a REST interface, we
 * use AWS API Gateway which gives us a URL and we tie that to our Lambda ARN.
 * There are two versions; the one ending in 'complex' is better after I figured
 * out little nits of API Gateway, but I think either will work because they both
 * point to the same Lambda.
 */
let ProductionURL =
  "https://vdubegvfb8.execute-api.us-east-1.amazonaws.com/complex2";
// The current beta URL is:
let BetaURL = "https://lc1bqlhbik.execute-api.us-east-1.amazonaws.com/Stage";
let BaseURL = ProductionURL;

// Detect if we're on the BETA site
//alert("Looking at href of:" + window.location.href);
if (
  window.location.href.indexOf("//7") !== -1 ||
  window.location.href.indexOf("//v7-") !== -1
) {
  BaseURL = BetaURL;
  //alert("Setting BaseURL to BetaURL:" + BaseURL);
} //else alert("using base/production url:" + BaseURL);
let clientVersion = "v7.7"; // HEY! If you change this, you MUST also change complex.js 'serverVersion' too!

if (process.env.REACT_APP_LAMBDA_URL)
  BaseURL = process.env.REACT_APP_LAMBDA_URL;
if (process.env.REACT_APP_VERSION)
  clientVersion = process.env.REACT_APP_VERSION;
console.log("Comm BaseURL:" + BaseURL + " Version:" + clientVersion);

let JWTToken = null;

const setJWTToken = (token) => (JWTToken = token);

async function awaitJson(stream) {
  let json;
  if (stream.status >= 400) {
    console.log("awaitJson: bad stream or error status:", stream);
    json = await stream.json();
    console.log("json result:", json);
    alert(
      "Unexpected communication failure, status:" +
        stream.status +
        " json:" +
        JSON.stringify(json)
    );
    /*eslint no-throw-literal: "off"*/
    throw { status: stream.status, json }; // We should make 'throwing' (or not) configurable
  }
  json = await stream.json();
  //console.log("awaitJson: json:", json);
  return json;
}

let makeHeader = () => {
  console.log("makeHeader:", JWTToken);
  if (JWTToken !== null)
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${JWTToken}`,
    };
  return {
    "Content-Type": "application/json",
  };
};

async function sendGET(url) {
  console.log("sendGET: url:", url);
  let stream = await fetch(BaseURL + url, {
    method: "GET",
    headers: { Authorization: `Bearer ${JWTToken}` },
  });
  console.log("sendGET: stream:", stream);
  return awaitJson(stream);
}

async function sendPOST(url, jsonObject, postOrPut = "POST") {
  console.log("sendPOST: url:", url, postOrPut, jsonObject);
  let fullURL = BaseURL + url;
  let stream = await fetch(fullURL, {
    method: postOrPut,
    body: JSON.stringify(jsonObject),
    headers: makeHeader(),
  });
  return awaitJson(stream);
}

async function sendDELETE(url, jsonObject) {
  console.log("sendDELETE: url:", url, "DELETE", jsonObject);
  let fullURL = BaseURL + url;
  let stream = await fetch(fullURL, {
    method: "DELETE",
    body: JSON.stringify(jsonObject),
    headers: makeHeader(),
  });
  return awaitJson(stream);
}

async function sendPUT(url, jsonObject, postOrPut = "PUT") {
  console.log("sendPOST: url:", url, postOrPut, jsonObject);
  let stream = await fetch(BaseURL + url, {
    method: postOrPut,
    body: JSON.stringify(jsonObject),
    headers: makeHeader(),
  });
  return awaitJson(stream);
}

export {
  sendGET,
  sendPOST,
  sendPUT,
  sendDELETE,
  setJWTToken,
  BaseURL,
  clientVersion,
};

export default {};
